var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserNoAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.709 20.9102C16.1582 20.9102 20.6699 16.3887 20.6699 10.9492C20.6699 5.5 16.1484 0.988281 10.6992 0.988281C5.25977 0.988281 0.748047 5.5 0.748047 10.9492C0.748047 16.3887 5.26953 20.9102 10.709 20.9102ZM10.709 14.2695C7.76953 14.2695 5.51367 15.3242 4.51758 16.4961C3.20898 15.0215 2.41797 13.0879 2.41797 10.9492C2.41797 6.33984 6.08984 2.64844 10.6992 2.64844C15.3086 2.64844 19 6.33984 19.0098 10.9492C19.0195 13.0879 18.2188 15.0312 16.9004 16.4961C15.9141 15.3242 13.6484 14.2695 10.709 14.2695ZM10.709 12.6094C12.5938 12.6289 14.0586 11.0273 14.0586 8.92773C14.0586 6.95508 12.584 5.32422 10.709 5.32422C8.83398 5.32422 7.34961 6.95508 7.35938 8.92773C7.36914 11.0273 8.83398 12.5898 10.709 12.6094Z",
    fill: "#FAECDF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserNoAvatar);
export default __webpack_public_path__ + "static/media/user-no-avatar.da9c18c62ad779d837dd2578c18181ee.svg";
export { ForwardRef as ReactComponent };